module.exports = __webpack_public_path__ + "img/book5.515a0c1f.png";